<template>
    <div>
        <div :class="{ 'show': modalShow }" class="modal fade">
            <form @submit.prevent="submitFormData">
                <div class="modal-dialog modal-xl modal-dialog-centered">
                    <div class="modal-content">
                        <div class="modal-header border-bottom">
                            <h5 class="modal-title h4 text-capitalize">
                                {{ (folderID ? $t('header.edit') : $t('header.add')) + 'Folder' }}
                                <small v-if="folderID" class="m-0 text-muted">Section - {{ name }}"</small>
                            </h5>
                            <button type="button" class="close" @click="modalShow = false">
                                <span aria-hidden="true"><i class="fal fa-times"></i></span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="tab-content">
                                <div class="row">

                                    <div class="col-sm-12 border-right">
                                        <div class="form-group">
                                            <label class="form-label">{{ $t('label.category') }}</label>
                                            <div class="input-group">
                                                <div class="input-group-prepend w-100">
                                                    <label class="input-group-text border-right-0">
                                                        <i class="fas fa-tag"></i>
                                                    </label>
                                                    <multiselect
                                                        :value="selectedSection"
                                                        :options="sections"
                                                        label="name"
                                                        track-by="sectionID"
                                                        :searchable="false"
                                                        :show-labels="false"
                                                        openDirection="below"
                                                        @select="onSectionChange">
                                                        <template slot="option" slot-scope="{ option }">
                                                            {{ option.name }}
                                                        </template>
                                                    </multiselect>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-sm-12 border-right">
                                        <div class="form-group">
                                            <label class="form-label">{{ $t('label.title') }}</label>
                                            <div class="input-group bg-white shadow-inset-2">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text bg-transparent border-right-0">
                                                        <i class="fas fa-text"></i>
                                                    </span>
                                                </div>
                                                <input type="text" class="form-control bg-transparent pl-3" :placeholder="$t('label.title')"
                                                    v-model="name"
                                                    required="">
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <div class="col-sm-12 border-right">
                                        <h6 class="text-dark fw-500">{{ $t('table.header.image') }}:</h6>
                                        <div id="imageContainer" v-if="icon != ''" class="text-center mt-3">
                                            <div class="text-right mb-2 mr-2">
                                                <button v-show="!dzShow" class="btn btn-sm btn-outline-primary" type="button"
                                                    :title="$t('header.delete_image')"
                                                    @click="showDeleteImageModal">
                                                    <span class="fal fa-trash"></span>
                                                </button>
                                            </div>
                                            <a @click="handleDropzone('img-thumbnail')" :title="$t('button_link.click_upload')" class="m-auto">
                                                <img class="img-fluid img-thumbnail" :src="icon" />
                                            </a>
                                        </div>
                                        <div v-else>
                                            <vue-dropzone
                                                ref="dropzone"
                                                class="text-center"
                                                id="dropzoneAdd"
                                                :options="dropOptions"
                                                @vdropzone-success="dropzoneAdd"
                                                @vdropzone-removed-file="dropzoneRemoved">
                                            </vue-dropzone>
                                        </div>
                                        <div v-if="dzShow" class="mt-2">
                                            <div class="row">
                                                <div class="col">
                                                    <h6 class="text-dark fs-sm">{{ $t('header.upload_image') }}: </h6>
                                                </div>
                                                <div class="col text-right">
                                                    <a id="uploadCancel" class="cancel link" @click="handleDropzone('item-image')">
                                                        {{ $t('button_link.cancel') }}
                                                    </a>
                                                </div>
                                            </div>
                                            <vue-dropzone ref="dropzone" class="text-center" id="dropzoneAdd" :options="dropOptions"
                                                @vdropzone-success="dropzoneAdd"></vue-dropzone>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <br>
                            <br>
                            <br>
                        </div>
                        <div class="modal-footer">
                            <div class="row w-100 no-gutters">
                                <div class="col">
                                    <button
                                        v-if="folderID"
                                        type="button"
                                        class="btn border-0 btn-danger btn-padding waves-effect waves-themed"
                                        @click="deleteItemConfirm">
                                        Delete
                                    </button>
                                </div>
                                <div class="col-auto">
                                    <button
                                        type="button"
                                        class="btn border-0 btn-secondary btn-padding waves-effect waves-themed mr-3"
                                        @click="returnItemList">
                                        {{ $t('button_link.cancel') }}
                                    </button>
                                </div>
                                <div class="col-auto">
                                    <button
                                        type="submit"
                                        class="btn border-0 btn-primary btn-padding waves-effect waves-themed">
                                        {{ $t('button_link.save') }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>

        <div :class="{ 'show': modalDeleteShow }" class="modal fade">
            <div class="modal-dialog modal-sm modal-dialog-centered">
                <div class="modal-content pt-3">
                    <div class="modal-body d-flex align-items-center">
                        Confirm delete {{ name }}?
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary waves-effect waves-themed" @click="modalDeleteShow = false">Cancel</button>
                        <button type="button" class="btn btn-primary waves-effect waves-themed" @click="deleteItem">OK</button>
                    </div>
                </div>
            </div>
        </div>

        <div :class="{ 'show': modalDeleteImageShow }" class="modal fade">
            <div class="modal-dialog modal-sm modal-dialog-centered">
                <div class="modal-content pt-3">
                    <div class="modal-body d-flex align-items-center">
                        Confirm delete image?
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary waves-effect waves-themed" @click="modalDeleteImageShow = false">Cancel</button>
                        <button type="button" class="btn btn-primary waves-effect waves-themed" @click="deleteItemImage">OK</button>
                    </div>
                </div>
            </div>
        </div>

        <div :class="{ 'show': errorModalShow }" class="modal fade">
            <div class="modal-dialog modal-sm modal-dialog-centered">
                <div class="modal-content pt-3">
                    <div class="modal-body d-flex align-items-center">
                        <i class="fas fa-2x" :class="isError ? ['fa-exclamation-circle', 'text-danger'] : ['fa-check-circle', 'text-success']"></i>
                        <p class="ml-3 mb-0" :class="isError ? ['text-danger'] : ['text-dark']">{{ errorMessage }}</p>
                    </div>
                    <div class="modal-footer">
                        <button id="modalClose" type="button" class="btn btn-primary waves-effect waves-themed" @click="closePopupModal()">OK</button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
import DeleteModal from './../../Delete_Modal'
import vueDropzone from "vue2-dropzone";
import { VueEditor } from "vue2-editor";
import VueTimepicker from 'vue2-timepicker'
import { setCategoryLabel, getCategoryText, getSubcategory, handleSessionExpired } from './../../../../assets/js/dashboard/dashboard'
import { convertToMin, formFormatTime, isNumber, getMessage } from './../../../../assets/js/dashboard/utilities'

export default {
    name: 'folderForm',
    props: {
        sections: {
            type: Array,
            default(rawProps) {
                return []
            },
        },
        sectionMap: {
            type: Object,
            default(rawProps) {
                return []
            },
        },
        categoryMap: {
            type: Object,
            default(rawProps) {
                return []
            },
        },
    },
    components: {
        vueDropzone,
    },
    data() {
        return {
            modalShow: false,
            isSpinnerShow: true,

            typeID: 2,
            folderID: 0,
            name: "",
            icon: '',
            selectedSection: {},

            modalDeleteShow: false,

            errorModalShow: false,
            isError: true,
            errorMessage: '',

            dzShow: false,
            dropOptions: {
                url: this.$api.API_IMAGE,
                addRemoveLinks: true,
                maxFiles: 1,
                paramName: 'filename',
                headers: {
                    token: this.$util.getSessionToken()
                }
            },
            modalDeleteImageShow: false,
        }
    },
    methods: {
        showAddModal(sectionID) {
            this.folderID = null
            this.name = ''
            this.icon = ''
            this.$refs.dropzone.removeAllFiles(true)

            this.selectedSection = this.sectionMap[sectionID] || this.sections[0]

            this.isSpinnerShow = false

            this.modalShow = true
        },
        async showEditModal(item) {
            this.folderID = item.folderID;
            this.name = item.name;
            this.icon = item.icon;
            this.$refs.dropzone.removeAllFiles(true)

            if (item.section && item.section.sectionID > 0) {
                this.selectedSection = this.sectionMap[item.section.sectionID] || {}
            } else {
                this.selectedSection = this.categoryMap[item.categoryID] || {}
            }

            this.modalShow = true
        },
        closeModal(isError) {
            if (!isError) {
                if (this.dzShow) {
                    this.$emit('renderItem')
                    this.dzShow = false
                } else {
                    this.onItemAddOrEdit()
                }
            }

            this.isSpinnerShow = true
            this.$parent.$parent.$parent.isModalShow = false
        },

        onSectionChange(item) {
            this.selectedSection = item
        },
        onItemAddOrEdit() {
            this.modalShow = false
            this.$emit('onItemAddOrEdit');
        },

        returnItemList() {
            this.modalShow = false
            this.$emit('returnItemList');
        },

        submitFormData() {
            var data = this.setFormData()
            this.submitForm(data, true, false)
        },
        setFormData() {
            var data = {}

            data['typeID'] = this.typeID
            data['folderID'] = this.folderID
            data['name'] = this.name
            data['sectionID'] = this.selectedSection.sectionID
            data['icon'] = this.addImagePath || this.icon

            return data
        },
        async submitForm(data) {
            let url
            if (this.folderID) {
                url = `https://menu.tunai.io/business/folder/${this.folderID}/update`
            } else {
                delete data['folderID']
                url = `https://menu.tunai.io/business/folder/`
            }

            this.$axios({
                method: 'post',
                url: url,
                headers: { token: this.$util.getSessionToken() },
                data: data,
            })
                .then((response) => {
                    if (response.status == 200) {
                        var action = this.folderID ? this.$i18n.t('message.success.action.update') : this.$i18n.t('message.success.action.add')
                        var retData = response.data;
                        var message = data['name'] + "' " + this.$i18n.t('message.success.success', { 'action': action })
                        this.$parent.$parent.$parent.setModal(this, false, true, message);

                        this.modalShow = false
                        this.onItemAddOrEdit()
                    }
                })
                .catch((err) => {
                    var errData = err.response.data;
                    if (errData.error == this.$api.INVALID_TOKEN) {
                        handleSessionExpired();
                    } else {
                        // this.$parent.$parent.$parent.setModal(this, true, false, this.$i18n.t('message.error.system_error'));
                        this.errorModalShow = true
                        this.errorMessage = this.$i18n.t('message.error.system_error')
                    }
                })
        },
        closePopupModal() {
            this.errorModalShow = false
        },

        deleteItemConfirm() {
            this.modalDeleteShow = true
        },
        deleteItem() {
            let url = `https://menu.tunai.io/business/folder/${this.folderID}/delete`

            this.$axios({
                method: 'post',
                url: url,
                headers: { token: this.$util.getSessionToken() },
            })
                .then((response) => {
                    if (response.status == 200) {
                        var message = 'Successfully remove ' + this.name
                        this.$parent.$parent.$parent.setModal(this, false, true, message);

                        this.modalDeleteShow = false
                        this.modalShow = false
                        this.onItemAddOrEdit()
                    }
                })
                .catch((err) => {
                    var errData = err.response.data;
                    if (errData.error == this.$api.INVALID_TOKEN) {
                        handleSessionExpired();
                    } else {
                        // this.$parent.$parent.$parent.setModal(this, true, false, this.$i18n.t('message.error.system_error'));
                        this.modalErrorShow = true
                        this.errorMessage = this.$i18n.t('message.error.system_error')
                    }
                })
        },

        dropzoneAdd(file, response) {
            if (response.path == undefined) {
                this.parent.$parent.$parent.setModal(this, false, true, this.$i18n.t('message.error.upload'));
            }

            if (this.folderID) {
                let imagePath = response.path

                this.$axios({
                    method: 'post',
                    url: `https://menu.tunai.io/business/folder/${this.folderID}/icon`,
                    headers: { token: this.$util.getSessionToken() },
                    data: { icon: response.path },
                })
                    .then((response) => {
                        if (response.status == 200) {
                            this.icon = imagePath
                            this.$emit('onItemAddOrEdit');
                            this.$refs.dropzone.removeFile(file)
                        }
                    })
                    .catch((err) => {
                        var errData = err.response.data;
                        if (errData.error == this.$api.INVALID_TOKEN) {
                            handleSessionExpired();
                        } else {
                            // this.$parent.$parent.$parent.setModal(this, true, false, this.$i18n.t('message.error.system_error'));
                            this.errorModalShow = true
                            this.errorMessage = this.$i18n.t('message.error.system_error')
                        }
                    })
            } else {
                this.addImagePath = response.path
            }
            // this.dzShow = true
        },
        dropzoneRemoved(file, error, xhr) {
            this.addImagePath = ''
        },
        handleDropzone(strClass) {
            var parent = document.getElementById("imageContainer");
            const imgs = parent.getElementsByClassName(strClass)

            var j = 0;
            if (imgs.length > 0) {
                for (var i = 0; i < imgs.length;) {
                    var img = imgs[i];
                    var link = img.parentElement;

                    if (img.classList.contains('img-thumbnail')) {
                        img.classList.remove('img-thumbnail');
                        img.classList.add('item-image');

                        link.classList.remove('m-auto');
                        link.classList.add('mr-2');
                        link.setAttribute('title', '');
                        parent.classList.add('d-flex');

                        this.dzShow = true;
                    } else {
                        img.classList.add('img-thumbnail');
                        img.classList.remove('item-image');

                        link.classList.add('m-auto');
                        link.classList.remove('mr-2');
                        link.setAttribute('title', this.$i18n.t('button_link.click_upload'));
                        parent.classList.remove('d-flex')

                        this.dzShow = false;
                    }
                    j++;
                }
            }
        },
        showDeleteImageModal() {
            this.modalDeleteImageShow = true
            // var title = this.$i18n.t('header.delete_image')
            // var message = this.$i18n.t('message.confirmation.delete_image')
            // this.$refs.deleteModal.showModal(title, message)
        },
        deleteItemImage() {
            if (this.folderID) {
                this.$axios({
                    method: 'post',
                    url: `https://menu.tunai.io/business/folder/${this.folderID}/icon`,
                    headers: { token: this.$util.getSessionToken() },
                    data: { icon: '' },
                })
                    .then((response) => {
                        if (response.status == 200) {
                            this.icon = ''
                            this.modalDeleteImageShow = false
                            this.$emit('onItemAddOrEdit');
                        }
                    })
                    .catch((err) => {
                        var errData = err.response.data;
                        if (errData.error == this.$api.INVALID_TOKEN) {
                            handleSessionExpired();
                        } else {
                            // this.$parent.$parent.$parent.setModal(this, true, false, this.$i18n.t('message.error.system_error'));
                            this.errorModalShow = true
                            this.errorMessage = this.$i18n.t('message.error.system_error')
                        }
                    })
            } else {
                this.addImagePath = ''
            }
        },
    },
    async mounted() {
    }
}
</script>
<style scoped>
.show {
    display: block;
}

.nav-link,
.link {
    cursor: pointer;
}

.img-thumbnail {
    width: 20em;
}

.item-image {
    width: 8em;
    opacity: .5;
}

.error-validation {
    font-size: 0.6875rem;
    margin-top: 0.325rem;
    color: #fd3995;
}
</style>